import React from 'react';
import { FadeInUp } from './ui/FadeInUp';
import { SectionEyebrow } from './ui/SectionEyebrow';
import { Calculator, Search, FileCheck } from 'lucide-react';
const tools = [{
  title: "Find Your Home's Value",
  desc: 'Get an instant, accurate home valuation powered by current market data.',
  btnText: 'Get My Home Value',
  icon: Calculator
}, {
  title: 'Search Homes for Sale',
  desc: 'Browse Phoenix Metro listings with our custom MLS search tool.',
  btnText: 'Start Searching',
  icon: Search
}, {
  title: 'Get Pre-Qualified',
  desc: 'Connect with our trusted lender Dan White Loans for a fast pre-qualification.',
  btnText: 'Get Pre-Qualified',
  icon: FileCheck
}];
export function ToolsSection() {
  return <section className="py-24 md:py-32 bg-sand" data-id="element-298">
      <div className="container mx-auto px-6" data-id="element-299">
        <FadeInUp className="text-center max-w-2xl mx-auto mb-16 md:mb-24" data-id="element-300">
          <SectionEyebrow text="Real Estate Tools" data-id="element-301" />
          <h2 className="text-4xl md:text-5xl font-serif text-charcoal" data-id="element-302">
            Powerful tools. Real answers.
          </h2>
        </FadeInUp>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-6xl mx-auto" data-id="element-303">
          {tools.map((tool, index) => {
          const Icon = tool.icon;
          return <FadeInUp key={tool.title} delay={index * 0.1} data-id="element-304">
                <div className="bg-white rounded-xl p-8 md:p-10 shadow-sm border border-sand/50 h-full flex flex-col items-center text-center transition-all duration-300 hover:-translate-y-2 hover:shadow-xl" data-id="element-305">
                  <div className="w-16 h-16 rounded-full bg-sand/30 flex items-center justify-center mb-6 text-terracotta" data-id="element-306">
                    <Icon strokeWidth={1.5} className="w-8 h-8" data-id="element-307" />
                  </div>
                  <h3 className="text-xl font-serif text-charcoal mb-4" data-id="element-308">
                    {tool.title}
                  </h3>
                  <p className="text-charcoal-text/80 leading-relaxed mb-8 flex-grow" data-id="element-309">
                    {tool.desc}
                  </p>
                  <a href="#" className="w-full py-3 px-6 bg-terracotta text-white rounded font-medium hover:bg-terracotta/90 transition-colors shadow-sm" data-id="element-310">
                    {tool.btnText}
                  </a>
                </div>
              </FadeInUp>;
        })}
        </div>
      </div>
    </section>;
}